<div class="tabs tab-vertical">
  {{!-- <div class=""> --}}
    <div class="tabs__tab-bar tab-card has-4tabs" role="tablist">

        <button href="#page_pane" id="page_tab" role="tab" data-toggle="tab" class="tabs__tab-bar-button tabs__tab-bar-button--active">
          <p class="tabs__tab-bar-button__text">Page Progress</p></button>

      {{#if local}}

        <button href="#survey_pane" id="survey_tab" role="tab" data-toggle="tab" class="tabs__tab-bar-button">
          <p class="tabs__tab-bar-button__text">Surveys</p></button>


        <button href="#assessment_pane" id="assessment_tab" role="tab" data-toggle="tab" class="tabs__tab-bar-button">
          <p class="tabs__tab-bar-button__text">Assessments</p></button>


        <button href="#action_plan_pane" id="action_plan_tab" role="tab" data-toggle="tab" class="tabs__tab-bar-button">
          <p class="tabs__tab-bar-button__text">Action Plan</p></button>

      {{/if}}
    </div>
  {{!-- </div> --}}
    <div class="tabs__tab-content bg-color-neutral-200 border-width-sm">
      <div role="tabpanel" class="tabs__tab-content__tab-pane active" id="page_pane">
        <div id="accordion" role="tablist" aria-multiselectable="true"></div>
      </div>
      {{#if local}}
      <div role="tabpanel" class="tabs__tab-content__tab-pane" id="survey_pane"></div>
      <div role="tabpanel" class="tabs__tab-content__tab-pane" id="assessment_pane"></div>
      <div role="tabpanel" class="tabs__tab-content__tab-pane" id="action_plan_pane"></div>
      {{/if}}
    </div>
  </div>
